export const getHistoryPageStyle = (_, { palette = {} }) => ({
  historyPageContainer: {
    '& #tab-selector-container': {
      marginLeft: 32,
      marginBottom: 12,
      '& button': {
        height: 39,
        background: palette.neutralLighter,
        border: 'none',
        paddingLeft: 12,
        paddingRight: 12,
        '&.selected': {
          background: palette.themeLighterAlt,
        },
      },
    },
  },
});
